export default __webpack_public_path__ + "static/media/zai_TriumphTypewriter.e8a94953.woff";